module.exports = __webpack_public_path__ + "static/media/02B.e01e002a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/02B.png
// module id = 259
// module chunks = 0